import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";

import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";

const SortingGradingForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "15%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "500px",
      maxHeight: "450px",
      height: "100%",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const frmRef = useRef({});
  const [loading, setLoading] = useState(false);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const gradeRef = useRef({});
  const [gradeDetails, setGradeDetails] = useState([]);
  const [salesGrade, setsalesGrade] = useState([]);

  const [gradeClose, setGradeClose] = useState(false);
  const [employeeData, setEmployeeData] = useState();
  const [weightUnits, setWeightUnits] = useState();
  const [varietyId, setVarietyId] = useState();
  const [totalQty, setTotalQty] = useState();

  const [totalInputProductCost, setTotalInputProductCost] = useState(0);
  const [diseasedDamagedCost, setdiseasedDamagedCost] = useState(0);

  const { sendRequest: getEmp } = useHttp();
  const { sendRequest: getgrade } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getLot } = useHttp();

  const [lotId, setLotId] = useState();

  useEffect(() => {
    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      process: "SRT",
    };
    getLot(
      {
        url: "/api/getStockLotForPackhouseProcess/",
        method: "POST",
        body: data,
      },
      (data) => {
        // //console.log(data);

        setLotId(data);
      }
    );
  }, [getLot]);

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);

          const weightUnits =
            res && res.filter((item) => item.unitTypeName == "Weight");

          setWeightUnits(weightUnits);
        }
      }
    );
  }, [getunits]);

  const handleLotIdChange = (e) => {
    // //console.log(e.target.value);
    const id = e.target.value;
    const data = lotId && lotId.filter((item) => item.stockId == id);
    console.log("data");
    console.log(data);
    frmRef.current.total_input_weight.value =
      data && data[0].productQuantityBal;
    frmRef.current.total_input_unit.value = data && data[0].unitName;
    setTotalInputProductCost(data && data[0].productAmountBal);
    // //console.log(data);
    const vId = data && data[0].varietyId;
    setVarietyId(data[0].varietyId || "");

    getgrade(
      {
        url: `/api/getsalesGradeMaster/?varietyId=${vId}`,
      },
      (res) => {
        if (res) {
          // //console.log(res.SalesGrade);
          const salesGrade = res.SalesGrade.filter(
            (item) => item.gradeType == "Sales"
          );
          // //console.log("salesGrade", salesGrade);

          setsalesGrade(salesGrade);
        }
      }
    );
  };

  const { sendRequest: postSortingGrading } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();


    var stockId = frmRef.current.lot_id.value;

    var lotlist = lotId.filter((item) => item.stockId == stockId);

    var lotfirst = lotlist && lotlist[0];
    var TotalOut = 0;
    var discardQty = 0;

    var productAmount = lotfirst.productAmount;

    var ipweightUnitlist = weightUnits.filter(
      (item) => item.unitId == lotfirst.unitId
    );

    if (lotfirst.unitId == frmRef.current.diseased_unit.value) {
      // //console.log("same unit");
      discardQty =
        discardQty + parseFloat(frmRef.current.diseased_damaged_weight.value);
    } else {
      var damageweightUnitlist = weightUnits.filter(
        (item) => item.unitId == frmRef.current.diseased_unit.value
      );

      var ipweightUnit = ipweightUnitlist && ipweightUnitlist[0];

      var damageweightUnit = damageweightUnitlist && damageweightUnitlist[0];

      discardQty =
        discardQty +
        parseFloat(frmRef.current.diseased_damaged_weight.value) *
          (parseFloat(damageweightUnit.conversionRation) /
            parseFloat(ipweightUnit.conversionRation));
    }

    var gradeTotalQty = 0;
    // //console.log("salesGrade", salesGrade);
    var ipweightUnitlist = weightUnits.filter(
      (item1) => item1.unitId == lotfirst.unitId
    );
    salesGrade.forEach((item) => {
      if (lotfirst.unitId == item.unitId) {
        // //console.log("same unit");
        gradeTotalQty = gradeTotalQty + parseFloat(item.itemQuantity);
        item["convertedQty"] = item.itemQuantity;
      } else {
        var damageweightUnitlist = weightUnits.filter(
          (item1) => item1.unitId == item.unitId
        );

        var ipweightUnit = ipweightUnitlist && ipweightUnitlist[0];

        var damageweightUnit = damageweightUnitlist && damageweightUnitlist[0];

        gradeTotalQty =
          gradeTotalQty +
          parseFloat(item.itemQuantity) *
            (parseFloat(damageweightUnit.conversionRation) /
              parseFloat(ipweightUnit.conversionRation));

        item["convertedQty"] =
          parseFloat(item.itemQuantity) *
          (parseFloat(damageweightUnit.conversionRation) /
            parseFloat(ipweightUnit.conversionRation));
      }
    });

    TotalOut = parseFloat(discardQty) + parseFloat(gradeTotalQty);
    setTotalQty(TotalOut);

    var inputQty = 0;
    inputQty = parseFloat(frmRef.current.total_input_weight.value);
    // //console.log(inputQty);

    if (TotalOut > inputQty) {
      toast.warn(
        "Damaged disposal weight and Grade Quantity is greater than total input weight"
      );
      
      return;
    } else {
      var ratePerunit = 0;
      ratePerunit = parseFloat(productAmount) / parseFloat(inputQty);
      ratePerunit = ratePerunit.toFixed(2);
      setdiseasedDamagedCost();
      salesGrade.forEach((item) => {
        item["productcost"] =
          parseFloat(item["convertedQty"]) * parseFloat(ratePerunit);
      });
      var discardWeight =
        parseFloat(frmRef.current.diseased_damaged_weight.value ?? 0) *
        parseFloat(ratePerunit);

      // //console.log("TotalOut+gradeTotalQty", discardQty + gradeTotalQty);
    }

    setLoading(true);

    const data = {
      sortingGradingDate: moment(frmRef.current.date.value).format(
        "DD/MM/YYYY"
      ),
      supervisorEmployeeId: frmRef.current.emp_id.value,
      stockId: frmRef.current.lot_id.value,

      totalInputWeight: frmRef.current.total_input_weight.value,
      // totalInputUnit: frmRef.current.total_input_unit.value,
      totalInputProductCost: totalInputProductCost,
      sizedCount: frmRef.current.sized_count.value,
      overSizedCount: frmRef.current.oversized_count.value,
      underSizedCount: frmRef.current.undersized_count.value,
      immatureCount: frmRef.current.immature_count.value,
      diseasedDamagedCount: frmRef.current.diseased_damaged_count.value,
      diseasedDamagedWeight: frmRef.current.diseased_damaged_weight.value,
      diseasedUnitId: frmRef.current.diseased_unit.value,
      diseasedDamagedCost: discardWeight,
      grade: salesGrade,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      createdDate: dateString,
      warehouseId: localStorage.getItem("warehouseId"),
      serviceId: props.sId,
    };

    // if (props.update) {
    //   data["sgId"] = props.update.sgId;
    // }
    // //console.log(data);
    postSortingGrading(
      {
        url: "/api/sortingGrading/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        // //console.log(data);
        toast.success("Sorting And Grading data added");
        setLoading(false);
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };
  useEffect(() => {
    // //console.log(props.update);

    if (props.update) {
      frmRef.current.date.value = moment(props.update.sgDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.lot_id.value = props.update.lotId;
      setProductDetails(props.update.productDetails);
      frmRef.current.total_input_weight.value = props.update.totalInputWeight;
      //frmRef.current.total_input_unit.value = props.update.totalInputUnit;
      frmRef.current.sized_count.value = props.update.sizedCount;
      frmRef.current.oversized_count.value = props.update.overSizedCount;
      frmRef.current.undersized_count.value = props.update.underSizedCount;
      frmRef.current.immature_count.value = props.update.immatureCount;
      frmRef.current.diseased_damaged_count.value =
        props.update.diseasedDamagedCount;
      frmRef.current.diseased_damaged_weight.value =
        props.update.diseasedDamagedWeight;
      frmRef.current.diseased_unit.value = props.update.diseasedUnit;
      frmRef.current.remark.value = props.update.remark;
      setGradeDetails(props.update.grade);
    }
  }, [props.update]);

  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,

        itemDescription: productRef.current.itemDescription.value,
        itemType: productRef.current.itemType.value,
        itemCategory: productRef.current.itemCategory.value,
        itemQuantity: productRef.current.itemQuantity.value,
        unit: productRef.current.unit.value,
      },
    ]);

    // //console.log(productDetails);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const handleGrade = (index, e) => {
    e.preventDefault();

    const itemQuantity = e.target.value;

    const updatedGardeDetails =
      salesGrade &&
      salesGrade.map((item, i) => {
        return {
          ...item,
          itemQuantity: i === index ? itemQuantity : item.itemQuantity,
          productcost: 0,
          remark: "product 1",
          createdBy: parseInt(localStorage.getItem("id")),
          orgId: localStorage.getItem("orgId"),
          status: 1,
          createdDate: dateString,
          warehouseId: localStorage.getItem("warehouseId"),
        };
      });

    // //console.log(updatedGardeDetails);

    setsalesGrade(updatedGardeDetails);
  };

  const handleGradeQty = (e, index) => {
    // //console.log(e.target.value);
    const id = e.target.value;

    const updatedGardeDetails = salesGrade.map((item, i) => {
      if (i === index) {
        return {
          ...item,

          unitId: id,
        };
      } else {
        return item;
      }
    });
    setsalesGrade(updatedGardeDetails);
  };

  // useEffect(() => {
  //   if (gradeClose && gradeDetails) {
  //     gradeRef.current.oversized.value = gradeDetails.oversized || "oversized";
  //     gradeRef.current.class1.value = gradeDetails.class1 || "";
  //     gradeRef.current.oversized_unit.value = gradeDetails.oversizedUnit || "";
  //     gradeRef.current.sized.value = gradeDetails.Sized || "sized";
  //     gradeRef.current.class2.value = gradeDetails.class2 || "";
  //     gradeRef.current.sized_unit.value = gradeDetails.sizedUnit || "";
  //     gradeRef.current.undersized.value =
  //       gradeDetails.undersized || "undersized";
  //     gradeRef.current.class2.value = gradeDetails.class3 || "";
  //     gradeRef.current.undersized_unit.value =
  //       gradeDetails.undersizedUnit || "";
  //   }
  // }, [gradeClose]);

  return (
    <>
      {gradeClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Grade Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setGradeClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <table className="table table-bordered table-sm text-center">
            <thead>
              <tr className="">
                <th>Class</th>
                <th>Class Quantity</th>

                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {salesGrade &&
                salesGrade.map((itm, i) => {
                  return (
                    <tr>
                      <td>{itm.gradeName}</td>

                      <td className="">
                        <div className="text-center">
                          <input
                            type={"input"}
                            id={"oversized"}
                            ref={(el) => (gradeRef.current["class_qty"] = el)}
                            defaultValue={itm.itemQuantity}
                            className="form-control"
                            onChange={
                              (event) => handleGrade(i, event)
                              // setsalesGrade[i].itemQuantity=event.target.value
                            }
                          />
                        </div>
                      </td>
                      <td>
                        <select
                          id="diseased_unit"
                          className="form-control dropdowns"
                          onChange={(e) => handleGradeQty(e, i)}
                          ref={(el) => (frmRef.current["unit"] = el)}
                        >
                          <option value="">Select</option>
                          {weightUnits &&
                            weightUnits.map((x) => (
                              <option value={x.unitId}>
                                {x.unitAbbreviation}
                              </option>
                            ))}
                        </select>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => setGradeClose(false)}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
      {close && (
        <Modal onClose={setClose}>
          <div className="flexRow">
            <div className="col-md-3">
              <label htmlFor={"srno"}> Sr. No</label>
              <span className={"form-control"}>
                {productDetails.length > 0
                  ? Number(
                      `${productDetails[productDetails.length - 1].srno}`
                    ) + 1
                  : 1}
              </span>
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemId"}> Item Id</label>
              <input
                type={"input"}
                id={"itemId"}
                required
                ref={(el) => (productRef.current["itemId"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemDescription"}> Item Description</label>
              <input
                type={"input"}
                id={"itemDescription"}
                required
                ref={(el) => (productRef.current["itemDescription"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemType"}> Item Type</label>
              <input
                type={"input"}
                id={"itemType"}
                required
                ref={(el) => (productRef.current["itemType"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemCategory"}> Item Category</label>
              <input
                type={"input"}
                id={"itemCategory"}
                required
                ref={(el) => (productRef.current["itemCategory"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemQuantity"}> Item Quantity</label>
              <input
                type={"number"}
                id={"itemQuantity"}
                required
                ref={(el) => (productRef.current["itemQuantity"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="flexRow">
            <div className="col-md-3">
              <label htmlFor={"unit"}>Unit</label>
              <select
                id="unit"
                className="drop-prod form-control"
                ref={(el) => (productRef.current["unit"] = el)}
                required
              >
                <option value="Number">Number</option>
                <option value="Miligram">Miligram</option>
                <option value="Gram">Gram</option>
                <option value="Kilogram">Kilogram</option>
                <option value="Milliliter">Milliliter</option>
                <option value="Liter">Liter</option>
                <option value="Tons">Tons</option>
              </select>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button className="product-add" onClick={submitProduct}>
              +
            </button>
            <button
              className="button-orange"
              onClick={() => {
                productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>

          <hr />

          <table className="product-listview ">
            {" "}
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Item Description</th>
                <th>Item Type</th>
                <th>Item Category/Variety</th>
                <th>Item Quantity</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.srno}</td>
                      <td>{itm.itemId}</td>
                      <td>{itm.itemDescription}</td>
                      <td>{itm.itemType}</td>
                      <td>{itm.itemCategory}</td>
                      <td>{itm.itemQuantity}</td>
                      <td>{itm.unit}</td>
                      <td>
                        <button
                          className="product-delete"
                          onClick={(e) => handleDelete(i, e)}
                        >
                          delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Sorting and Grading Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Assigned Supervisor"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                      >
                        {employeeData &&
                          employeeData.map((x) => (
                            <option value={x.empId}>{x.employeeName}</option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"lot_id"}>{"Lot id "}</label>
                      <select
                        id="lot_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["lot_id"] = el)}
                        onChange={handleLotIdChange}
                      >
                        <option value="">Select</option>
                        {lotId &&
                          lotId.map((x) => (
                            <option value={x.stockId}>
                              {x.lotNo + "(" + x.productName + ")"}
                              {/* {x.lotNo + x.docNo + "(" + x.productName + ")"} */}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_input_weight"}>
                        {"Total input Weight"}
                      </label>
                      <input
                        type={"number"}
                        id={"total_input_weight"}
                        required
                        ref={(el) =>
                          (frmRef.current["total_input_weight"] = el)
                        }
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"total_input_unit"}>{"Unit"}</label>
                      <input
                        type={"input"}
                        id={"total_input_unit"}
                        ref={(el) => (frmRef.current["total_input_unit"] = el)}
                        className="form-control"
                        readOnly
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"undersized_count"}>
                        {"UnderSized Count(50-60mm)"}
                      </label>
                      <input
                        type={"number"}
                        id={"undersized_count"}
                        required
                        ref={(el) => (frmRef.current["undersized_count"] = el)}
                        className="form-control"
                      />
                    </div>{" "}
                    <div className="col-md-3">
                      <label htmlFor={"sized_count"}>
                        {"Sized Count(60-70mm)"}
                      </label>
                      <input
                        type={"number"}
                        id={"sized_count"}
                        required
                        ref={(el) => (frmRef.current["sized_count"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"oversized_count"}>
                        {"Oversized Count(70-80mm)"}
                      </label>
                      <input
                        type={"number"}
                        id={"oversized_count"}
                        required
                        ref={(el) => (frmRef.current["oversized_count"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"immature_count"}>
                        {"Immature/Scarred Count"}
                      </label>
                      <input
                        type={"number"}
                        id={"immature_count"}
                        required
                        ref={(el) => (frmRef.current["immature_count"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"diseased_damaged_count"}>
                        {"Diseased Damaged Count"}
                      </label>
                      <input
                        type={"number"}
                        id={"diseased_damaged_count"}
                        required
                        ref={(el) =>
                          (frmRef.current["diseased_damaged_count"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"diseased_damaged_weight"}>
                        {"Damaged disposal in Weight"}
                      </label>
                      <input
                        type={"number"}
                        id={"diseased_damaged_weight"}
                        required
                        ref={(el) =>
                          (frmRef.current["diseased_damaged_weight"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"diseased_unit"}>{"Unit"}</label>
                      <select
                        id="diseased_unit"
                        className="form-control"
                        ref={(el) => (frmRef.current["diseased_unit"] = el)}
                      >
                        <option value="">Select</option>
                        {weightUnits &&
                          weightUnits.map((x) => (
                            <option value={x.unitId}>
                              {x.unitAbbreviation}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"grade"}>{"Grade"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"grade"}
                        ref={(el) => (frmRef.current["grade"] = el)}
                        className="btn btn-sm btn-success"
                        autoComplete="off"
                        onClick={() => {
                          setGradeClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2"></div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SortingGradingForm;
